import React from 'react'
import "./styles/footer.scss"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import {
  useGetContactContentDataQuery,
} from "../../services/contactAPI";
import { useGetFooterContentQuery, useGetPaymentIconsQuery } from '../../services/commonAPI';
import Loader from "../pages/fullPageLoader"
import PaypalIcon from "../../assets/images/payment-icons/paypal-icon.webp"
import StripeIcon from "../../assets/images/payment-icons/stripe-icon.png"
import RazerPayIcon from "../../assets/images/payment-icons/razorpay.webp"
import SquareIcon from "../../assets/images/payment-icons/square-icon.png"
import GooglePayIcon from "../../assets/images/payment-icons/google-pay-icon.jpeg"
import AppleIcon from "../../assets/images/payment-icons/apple-pay.jpg"
import VisaIcon from "../../assets/images/payment-icons/visa-card.webp"
import MasterCardIcon from "../../assets/images/payment-icons/master-card.avif"
import AmericanIcon from "../../assets/images/payment-icons/american_express.webp"
import DiscoverIcon from "../../assets/images/payment-icons/discover.webp"

function Footer() {

  const {
    data: contactContent,
  } = useGetContactContentDataQuery();

  const {
    data: footerContent,
    error: footerContentError,
    isLoading: footerContentLoading,
  } = useGetFooterContentQuery();

  const { data: paymentGatewayIcons } = useGetPaymentIconsQuery();

  console.log("paymentGatewayIcons", paymentGatewayIcons)

  const contactSection = contactContent?.data?.[0];
  const footerSecContent = footerContent?.data?.[0];
  localStorage.setItem("Appname", footerSecContent?.copyright_app_name);
  localStorage.setItem("favIcon", footerSecContent?.fav_icon_path);


  const accessToken = localStorage.getItem("access_token");
  const user_id = localStorage.getItem("gridMarker");

  const paymentGatewayImages = {
    "PayPal": PaypalIcon,
    "Stripe": StripeIcon,
    "Razorpay": RazerPayIcon,
    "Square": SquareIcon,
    "Google Pay": GooglePayIcon,
    "Apple Pay": AppleIcon,
    "Visa": VisaIcon,
    "MasterCard": MasterCardIcon,
    "American Express": AmericanIcon,
    "Discover": DiscoverIcon,
  };

  if (footerContentLoading) return <Loader />;
  if (footerContentError) return <p>Failed to load data</p>;

  return (
    <footer>
      <section className='footer-top'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-4 col-sm-12 col-lg-4'>
              <div>

                <h3>CONTACT US</h3>

                <div className='d-flex'>
                  {contactSection?.facebook && (
                    <div className='social-media-icons'>
                      <Link to={`https://${contactSection.facebook}`} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faFacebook} />
                      </Link>
                    </div>
                  )}

                  {contactSection?.instagram && (
                    <div className='social-media-icons'>
                      <Link to={`https://${contactSection.instagram}`} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faInstagram} />
                      </Link>
                    </div>
                  )}

                  {contactSection?.twitter && (
                    <div className='social-media-icons'>
                      <Link to={`https://${contactSection.twitter}`} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faTwitter} />
                      </Link>
                    </div>
                  )}

                  {contactSection?.youtube && (
                    <div className='social-media-icons'>
                      <Link to={`https://${contactSection.youtube}`} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faYoutube} />
                      </Link>
                    </div>
                  )}

                </div>
                <div className="mt-30 contact-icons text-start">
                  {contactSection?.phone && (
                    <p>
                      <FontAwesomeIcon icon={faPhone} />
                      <a href={`tel:${contactSection.phone}`} className="ms-2">
                        {contactSection.phone}
                      </a>
                    </p>
                  )}
                  {contactSection?.email && (
                    <p>
                      <FontAwesomeIcon icon={faEnvelope} />
                      <a href={`mailto:${contactSection.email}`} className="ms-2">
                        {contactSection.email}
                      </a>
                    </p>
                  )}
                </div>



              </div>
            </div>

            <div className='col-md-4 col-sm-12 col-lg-4'>
              <div>

                <h3>MY ACCOUNT</h3>
                <ul>
                  <li>{footerSecContent?.login_active === 1 && <Link to={(!accessToken && !user_id) ? "/login" : "/my-account"}>LOGIN</Link>}</li>
                  <li>{footerSecContent?.register_active === 1 && <Link to={(!accessToken && !user_id) ? "/register" : "/my-account"}>REGISTER</Link>}</li>
                  <li> {footerSecContent?.wishlist_active === 1 && <Link to="/wishlist">WISHLIST</Link>}</li>
                  <li>{footerSecContent?.track_order_active === 1 && <Link to="/cart-page">TRACK YOUR ORDERS</Link>}</li>
                </ul>
              </div>
            </div>

            <div className='col-md-4 col-sm-12 col-lg-4'>
              <h3>USEFULL LINKS</h3>
              <div>
                <ul>
                  <li>{footerSecContent?.about_us_active === 1 && <Link to="/about">ABOUT US</Link>}</li>
                  {/* {footerSecContent?.how_to_order_active === 1 && <li>HOW TO ORDER</li>}
                  {footerSecContent?.how_to_track_active === 1 && <li>HOW TO TRACK</li>}
                  {footerSecContent?.size_track_active === 1 && <li>SIZE TRACK</li>} */}

                </ul>
              </div>
            </div>
          </div>
        </div>

      </section>
      <section className='footer-bottom'>
        <div className='container'>
          <div className='d-flex justify-space-between'>
            <div>
              <p>Copyright © {new Date().getFullYear()} {footerSecContent?.copyright_app_name} </p>
            </div>
            <div className="footer-logo-images">
              <p className='privacy-policy'>{footerSecContent?.how_to_order_active ? (
                <Link to="/privacy-policy">Privacy Policy</Link>
              ) : (
                ""
              )}
                {footerSecContent?.how_to_track_active ? (<Link to="/terms-and-conditions"> | Terms and Conditions</Link>) : ("")}
                <Link to="/shipping-policy"> | Shipping Policy</Link>
                <Link to="/refund-policy"> | Refund Policy</Link>
              </p>
              {/* {footerSecContent?.footer_images?.map((image, index) => (
                <div key={index}>
                  <img
                    src={image}
                    alt="img"
                    className={footerSecContent?.footer_images?.length === 1 ? "single-image" : "credit-card-images"}
                    loading="lazy"
                  />
                </div>
              ))} */}
              <div className='d-flex justify-content-center'>
                {
                  paymentGatewayIcons?.map((icon, index) => {
                    // Ensure that icon.status is a number and check for the correct value
                    if (Number(icon.status) === 1) {
                      const imagePath = paymentGatewayImages[icon.name];

                      return (
                        <div key={index}>
                          <img
                            src={imagePath}
                            alt={icon.name}
                            className={paymentGatewayIcons?.length === 1 ? "single-image" : "credit-card-images"}
                            loading="lazy"
                          />
                        </div>
                      );
                    }
                    // Optional: Log out the icons that don't match the condition
                    console.log("Skipping icon with status", icon.name, icon.status);
                    return null; // Return null for icons with status 0
                  })
                }
              </div>



            </div>

          </div>
        </div>

      </section>
    </footer>
  )
}

export default Footer